import { type FC, useState } from 'react';
import { useFragment, graphql } from 'react-relay';

import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { NftAvatarCircle } from 'dibs-crypto-utils/exports/NftAvatarCircle';
import { ConnectedWalletMenuContent } from './ConnectedWalletMenuContent';

import { type ConnectedWalletMobileMenu_user$key } from './__generated__/ConnectedWalletMobileMenu_user.graphql';
import styles from './styles/ConnectedWalletStatus.scss';

type Props = {
    user: ConnectedWalletMobileMenu_user$key;
    showEditorial: boolean;
    hideCreate: boolean;
};

export const ConnectedWalletMobileMenu: FC<Props> = ({
    user: userRef,
    showEditorial,
    hideCreate,
}) => {
    const user = useFragment(
        graphql`
            fragment ConnectedWalletMobileMenu_user on User {
                ...ConnectedWalletMenuContent_user
                profile {
                    displayName
                }
                ethereumWalletAddress {
                    ...NftAvatarCircle_address
                    address
                }
            }
        `,
        userRef
    );
    const { ethereumWalletAddress } = user;
    const { address: persistedAddress } = ethereumWalletAddress || {};
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    if (!persistedAddress) {
        return null;
    }

    return (
        <>
            <Link
                className={styles.imgLinkWrapper}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
                <NftAvatarCircle
                    address={ethereumWalletAddress}
                    wrapperClassName={styles.imgLinkWrapper}
                />
            </Link>
            <div
                className={classnames(styles.mobileAccountMenuBackdrop, {
                    [styles.isOpen]: isMobileMenuOpen,
                })}
            />
            <div
                className={classnames(styles.accountMobileMenu, {
                    [styles.isOpen]: isMobileMenuOpen,
                })}
            >
                <ConnectedWalletMenuContent
                    user={user}
                    onCloseButtonClick={() => setIsMobileMenuOpen(false)}
                    showCreateButton={!hideCreate}
                    showEditorial={showEditorial}
                />
            </div>
        </>
    );
};
